@if (display) {
  <div class="{{ class }}" role="status" aria-label="Loading">
    <mat-spinner [diameter]="diameter"></mat-spinner>
    <br />
    <h4>{{ messageToDisplay }}</h4>
  </div>
}
